"use strict";

require("core-js/modules/es.array.flat-map");

require("core-js/modules/es.array.unscopables.flat-map");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable no-shadow */


function extractMinWidths(breakpoints) {
  return _lodash.default.flatMap(breakpoints, function (breakpoints) {
    if (_lodash.default.isString(breakpoints)) {
      breakpoints = {
        min: breakpoints
      };
    }

    if (!Array.isArray(breakpoints)) {
      breakpoints = [breakpoints];
    }

    return (0, _lodash.default)(breakpoints).filter(function (breakpoint) {
      return _lodash.default.has(breakpoint, 'min') || _lodash.default.has(breakpoint, 'min-width');
    }).map(function (breakpoint) {
      return _lodash.default.get(breakpoint, 'min-width', breakpoint.min);
    }).value();
  });
}

function mapMinWidthsToPadding(minWidths, screens, paddings) {
  if (typeof paddings === 'undefined') {
    return [];
  }

  if (!_lodash.default.isObject(paddings)) {
    return [{
      screen: 'default',
      minWidth: 0,
      padding: paddings
    }];
  }

  var mapping = [];

  if (paddings.default) {
    mapping.push({
      screen: 'default',
      minWidth: 0,
      padding: paddings.default
    });
  }

  _lodash.default.each(minWidths, function (minWidth) {
    Object.keys(screens).forEach(function (screen) {
      if ("".concat(screens[screen]) === "".concat(minWidth)) {
        mapping.push({
          screen: screen,
          minWidth: minWidth,
          padding: paddings[screen]
        });
      }
    });
  });

  return mapping;
}

module.exports = function () {
  return function (_ref) {
    var addComponents = _ref.addComponents,
        theme = _ref.theme;
    var screens = theme('container.screens', theme('screens'));
    var minWidths = extractMinWidths(screens);
    var paddings = mapMinWidthsToPadding(minWidths, screens, theme('container.padding'));

    var generatePaddingFor = function generatePaddingFor(minWidth) {
      var paddingConfig = _lodash.default.find(paddings, function (padding) {
        return "".concat(padding.minWidth) === "".concat(minWidth);
      });

      if (!paddingConfig) {
        return {};
      }

      return {
        paddingRight: paddingConfig.padding,
        paddingLeft: paddingConfig.padding
      };
    };

    var atRules = (0, _lodash.default)(minWidths).sortBy(function (minWidth) {
      return parseInt(minWidth);
    }).sortedUniq().map(function (minWidth) {
      return _defineProperty({}, "@media (min-width: ".concat(minWidth, ")"), {
        '.container': _objectSpread({
          'max-width': minWidth
        }, generatePaddingFor(minWidth))
      });
    }).value();
    addComponents([{
      '.container': Object.assign({
        width: '100%'
      }, theme('container.center', false) ? {
        marginRight: 'auto',
        marginLeft: 'auto'
      } : {}, generatePaddingFor(0))
    }].concat(_toConsumableArray(atRules)));
  };
};